

import Vue from 'vue'
import router from '@/router'
import store from '@/store'

export function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //匹配字段
	if (arr = document.cookie.match(reg)) {
		return decodeURIComponent(arr[2]);
	} else {
		return null;
	}
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 获取枚举描述
 * @param {*} value 值
 * @param {*} list 枚举列表
 * @param {*} id 值的key
 * @param {*} name 描述的key
 */
export function getSelectDesc (value, list = [], id = 'id', name = 'name') {
  let ind = list.findIndex((item) => item[id] === value)
  if (ind > -1) {
    return list[ind][name]
  } else {
    return ''
  }
}

export function findMenuOfUrl(menuList, url) {
  if (!menuList || !url) return null
  for (const item of menuList) {
    if (item.jumpUrl === url) {
      return item.id
    }
    if (item.children && item.children.length) {
      const result = findMenuOfUrl(item.children, url);
      if (result !== null) {
        return result;
      }
    }
  }
  return null
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('token')
  Vue.cookie.delete('accountId')
  Vue.cookie.delete('userId')
  Vue.cookie.delete('tenantId')
  Vue.cookie.delete('realName')
  Vue.cookie.delete('username')
  Vue.cookie.delete('mobile')
  Vue.cookie.delete('isOuter')
  Vue.cookie.delete('avatarUrl')

  store.commit('resetStore')
  router.options.isAddDynamicMenuRoutes = false
}


// WEBPACK FOOTER //
// ./src/utils/index.js